module.exports = __webpack_public_path__ + "static/media/green-eclipse.8bfb537c.png";